window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.ChangeCardOnFile.init());

Sq.Shop.ChangeCardOnFile = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#change-card-on-file-form').length === 0) {
      return;
    }

    this.bindEvents();
  },

  bindEvents() {
    $(document).on('click', '#change-card-on-file .modal-close-button', () => {
      this.utils.flashBanner().hide();
    });
  },
};
